class ShopifyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.lastScrollTop = 0;
    this.ticking = false;
  }

  connectedCallback() {
    this.menuType = this.dataset.menuType;
    this.stickyBehavior = this.dataset.stickyBehavior;
    this.mobileMenuType = this.dataset.mobileMenuType;
    this.submenuAction = this.dataset.submenuAction;
    this.setupStickyHeader();

    if (this.menuType === 'dropdown' || this.menuType === 'mega') {
      this.setupDesktopSubmenuBehavior();
    }

    this.setupMenuDrawer();
    this.setupPredictiveSearch();
    this.setupAnnouncementBarClose();
  }

  setupStickyHeader() {
    this.headerHeight = this.header.offsetHeight;
    this.announcementBar = document.querySelector('.announcement-bar');
    this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
  
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBarHeight}px`);
    document.documentElement.style.setProperty('scroll-padding-top', `calc(var(--announcement-bar-height) + var(--header-height))`);
  
    if (this.stickyBehavior === 'always' || this.stickyBehavior === 'scroll_up') {
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.updateHeaderVisibility();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateHeaderVisibility() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerBottom = this.header.getBoundingClientRect().bottom;
    const announcementBarBottom = this.announcementBar ? this.announcementBar.getBoundingClientRect().bottom : -1;

    // if (scrollTop > this.announcementBarHeight && this.stickyBehavior === 'always') {
    //   this.header.classList.add('fixed', 'top-0');
    //   this.header.style.transform = 'translateY(0)';
    //   this.header.style.transform = `translateY(${this.announcementBarHeight}px)`;
    // } else if (this.announcementBar && announcementBarBottom >= 0) {
    //   this.header.classList.remove('fixed', 'top-0');
    //   this.header.style.transform = '';
    // }

    if (this.stickyBehavior === 'always') {
      this.header.classList.add('fixed');
      this.header.style.top = this.announcementBarHeight + 'px'
    } else if (this.announcementBar && announcementBarBottom >= 0) {
      this.header.classList.remove('fixed', 'top-0');
      this.header.style.transform = '';
    }

    if (this.stickyBehavior === 'scroll_up') {
      if (scrollTop < this.lastScrollTop && headerBottom <= 0) {
        this.header.classList.add('fixed', 'top-0');
        this.header.style.transform = 'translateY(0)';
      } else if (scrollTop > this.lastScrollTop && scrollTop > this.headerHeight + this.announcementBarHeight) {
        this.header.style.transform = `translateY(-${this.headerHeight}px)`;
      }
    }

    this.lastScrollTop = scrollTop;
  }

  setupDesktopSubmenuBehavior() {
    const menuItems = this.header.querySelectorAll('nav > ul > li');

    menuItems.forEach(item => {
      const submenu = item.querySelector('ul') || item.querySelector('.mega-menu');
      if (submenu) {
        if (this.submenuAction === 'hover') {
          item.addEventListener('mouseenter', () => {
            item.classList.add('active-menu-link');
          });
          item.addEventListener('mouseleave', () => {
            item.classList.remove('active-menu-link');
          });
        } else if (this.submenuAction === 'click') {
          item.querySelector('a').addEventListener('click', (e) => {
            e.preventDefault();
            item.classList.toggle('active-menu-link');
            menuItems.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('active-menu-link');
              }
            });
          });

          document.addEventListener('click', (e) => {
            if (!item.contains(e.target)) {
              item.classList.remove('active-menu-link');
            }
          });
        }
      }
    });
  }

  setupMenuDrawer() {
    const menuToggle = this.header.querySelector('#menu-toggle');
    const menuLinkToggles = this.header.querySelectorAll('.menu-link-toggle')
    const menuDrawer = this.header.querySelector('#menu-drawer');
    const menuIcon = menuToggle.querySelector('.menu-icon');
    const closeIcon = menuToggle.querySelector('.close-icon');
    const overlay = this.header.querySelector('#drawer-overlay');

    this.setDrawerHeight();
    window.addEventListener('resize', this.setDrawerHeight.bind(this));
    window.addEventListener('scroll', this.setDrawerHeight.bind(this));

    menuToggle.addEventListener('click', () => {
      this.toggleDrawer(menuDrawer, menuIcon, closeIcon, overlay);
    });

    menuLinkToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        this.toggleDrawer(menuDrawer, menuIcon, closeIcon, overlay)
      })
    })

    overlay.addEventListener('click', () => {
      this.toggleDrawer(menuDrawer, menuIcon, closeIcon, overlay);
    });

    if (this.mobileMenuType !== 'accordion') {
      this.setupNewPageInDrawer(menuDrawer);
    }
  }

  setDrawerHeight() {
    const headerHeight = this.header.offsetHeight;
    const announcementBar = document.querySelector('.announcement-bar');
    let announcementBarVisibleHeight = 0;
  
    if (announcementBar) {
      const announcementBarRect = announcementBar.getBoundingClientRect();
      announcementBarVisibleHeight = Math.max(0, announcementBarRect.height - Math.abs(announcementBarRect.top));
    }
  
    const totalHeight = headerHeight + announcementBarVisibleHeight;
    const menuDrawer = this.header.querySelector('#menu-drawer');
    const menuDrawerOverlay = this.header.querySelector('#drawer-overlay');
    menuDrawer.style.height = `calc(100dvh - ${totalHeight}px)`;
    menuDrawer.style.top = `${totalHeight}px`;
    menuDrawerOverlay.style.height = `calc(100dvh - ${totalHeight}px)`;
    menuDrawerOverlay.style.top = `${totalHeight}px`;
  }

  toggleDrawer(menuDrawer, menuIcon, closeIcon, overlay) {
    menuDrawer.classList.toggle('-translate-x-full');
    menuIcon.classList.toggle('hidden');
    closeIcon.classList.toggle('hidden');
    document.body.classList.toggle('overflow-hidden');
    overlay.classList.toggle('hidden');
  }

  setupNewPageInDrawer(menuDrawer) {
    const submenuTriggers = menuDrawer.querySelectorAll('.submenu-trigger');
    submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const submenuId = e.target.dataset.submenu;
        const submenu = this.header.querySelector(`#submenu-${submenuId}`);
        submenu.classList.remove('hidden');
      });
    });

    const submenuBackButtons = menuDrawer.querySelectorAll('.submenu-back');
    submenuBackButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.target.closest('.submenu').classList.add('hidden');
      });
    });
  }

  setupPredictiveSearch() {
    const searchToggle = this.header.querySelector('#search-toggle');
    const predictiveSearch = this.header.querySelector('#predictive-search');
    const resultsWrapper = this.header.querySelector('#search-results-wrapper');
    const searchClose = this.header.querySelector('#search-close');
    const searchInput = this.header.querySelector('#search-input');
    const searchResults = this.header.querySelector('#search-results');
    const searchClear = this.header.querySelector('#search-clear');
    
    if (!searchToggle || !searchClose || !searchClear || !predictiveSearch || !searchInput || !searchResults || !resultsWrapper) return
    searchToggle.addEventListener('click', () => {
      predictiveSearch.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
      searchInput.focus();
    });
  
    searchClose.addEventListener('click', () => {
      predictiveSearch.classList.add('hidden');
      resultsWrapper.classList.add('hidden')
      searchInput.value = '';
      searchResults.innerHTML = '';
      document.body.classList.remove('overflow-hidden');
    });

    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      searchResults.innerHTML = '';
      searchClear.classList.add('hidden');
      searchInput.focus();
    });

    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    searchInput.addEventListener('input', debounce(async (e) => {
      const query = e.target.value.trim();
  
      if (query.length > 2) {
        searchClear.classList.remove('hidden');
  
        try {
          const response = await fetch(`/search/suggest?q=${query}&section_id=predictive-search`);
          // const response1 = await fetch(`/search/suggest.json?q=${query}`);
          // const data = await response1.json();
          // console.log(data)
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const text = await response.text();
          const parser = new DOMParser();
          const parsedDocument = parser.parseFromString(text, 'text/html');

          searchResults.parentElement.classList.remove('hidden');
          searchResults.parentElement.classList.add('flex');
  
          const resultsMarkup = parsedDocument.querySelector('#predictive-search-results')?.innerHTML || '';
          searchResults.innerHTML = resultsMarkup;

        } catch (error) {
          console.error('Error fetching search results:', error);
        }
      } else {
        searchResults.innerHTML = '';
        searchClear.classList.add('hidden');
      }
    }, 300));
  }
  
  setupAnnouncementBarClose() {
    const announcementCloseButton = this.announcementBar?.querySelector('#announcement-close');
    if (announcementCloseButton) {
      announcementCloseButton.addEventListener('click', () => {
        this.announcementBar.classList.add('hidden');
        this.announcementBar.classList.remove('announcement-bar');
        this.setDrawerHeight();
        this.setupStickyHeader();
      });
    }
  }
}

customElements.define('header-487', ShopifyHeader);